
import { DateHelpers } from '@edl-development/edl-common';
import { Schedule } from './schedule.model';
export class LastWeekSchedule extends Schedule {

    constructor(){
        super();
        let now = new Date();
        this.EndDate = DateHelpers.DateToShortDate(new Date());
        this.StartDate = DateHelpers.DateToShortDate(new Date(now.setDate(now.getDate() - 7)));
        
    }
}